



















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AskeperProgressStepper extends Vue {
  @Prop({ default: false }) readonly preCompleted!: boolean;
  @Prop({ default: false }) readonly intraCompleted!: boolean;
  @Prop({ default: false }) readonly postCompleted!: boolean;
  @Prop({ default: 0 }) readonly progressPercent!: number;

  get progressColor(): string {
    if (this.progressPercent >= 100) return "success";
    if (this.progressPercent >= 50) return "primary";
    return "warning";
  }
}
